import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getShipManagementDetails,
  getShipManagementList,
  getShipEquipmentDetails,
} from "../Actions/ShipManagementAPI";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { getShipSearchlist } from "../Actions/MMPLDashboardAPI";
import swal from "sweetalert";
import {
  getFlagList,
  getClientUsersList,
  getClassList,
  getClientNameList,
  getTypeofShipList,
} from "../Actions/helpersAPI";
import axios from "axios";
import API from "../helpers/api";
import { postFirePlanAttachment } from "../Actions/CommonAPI";
import Moment from "moment";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));
let searchData = {
  IsClient: false,
  shipName: "",
  category: "",
  imoNo: "",
  client: "",
  status: "Pending",
  serviceStatus: "",
  nextServiceDateFrom: "",
  nextServiceDateTo: "",
  pagesize: 25,
  pagenumber: 1,
  noofrecords: 2,
  ServiceTypes: [],
  isTotalShips: true,
  isOverdueShips: false,
  isShipsDue10: false,
  isShipsDue30: false,
  isShipsDue60: false,
  isShipsDue90: false,
  action: 1,
};
class ShipEquipmentEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipInfo: {
        shipId: 0,
        contractId: 0,
        shipName: "",
        flag: "",
        class: "",
        firePlanName: "",
        firePlanGUID: "",
        grt: "",
        imoNo: "",
        status: "",
        deadWeight: "",
        dateOfBuild: "",
        enrollmentDate: "",
        approverId: 0,
        grantAdminId: 0,
        typeOfShip: "",
        shipEmail: "",
        invoiceForwardingEmail: "",
        vesselGroupEmail: "",
        phone1: "",
        phone2: "",
        companyName: "",
        contractName: "",
        contractStatus: "pending",
        modifiedBy: currentUser.name,
        isDeleted: false,
        shipUsers: [],
      },
      pending: false,
      active: false,
      terminated: false,
      Equipmentlist: [],
      DatePickerIsOpen: "",
      inContract: false,
      notInContract: false,
      isBoth: true,
    };
    this.UpdateShip = this.UpdateShip.bind(this);
    this.AssignApprover = this.AssignApprover.bind(this);
  }

  componentDidMount() {
    const { dispatch, companyName, match } = this.props;
    dispatch(getShipEquipmentDetails(match.params.id));
    dispatch(getShipManagementDetails(match.params.id));
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { EquipmentArray, dispatch, ShipDetails } = nextProps;
    if (ShipDetails && ShipDetails !== "") {
      prevState.shipInfo.shipId = ShipDetails.shipId;
      prevState.shipInfo.shipName = ShipDetails.shipName;
      prevState.shipInfo.imoNo = ShipDetails.imoNo;
      prevState.fileName = ShipDetails.firePlanName;
      prevState.shipInfo.flag = ShipDetails.flag;
      prevState.shipInfo.class = ShipDetails.class;
      prevState.shipInfo.grt = ShipDetails.grt;
      prevState.shipInfo.typeOfShip = ShipDetails.typeOfShip;
      prevState.shipInfo.dateOfBuild = Moment(
        new Date(Date.parse(ShipDetails.dateOfBuild))
      ).format("YYYY-MM-DD");
      prevState.shipInfo.enrollmentDate = ShipDetails.enrollmentDate
        ? Moment(new Date(Date.parse(ShipDetails.enrollmentDate))).format(
            "YYYY-MM-DD"
          )
        : "";
      prevState.shipInfo.deadWeight = ShipDetails.deadWeight;
      prevState.shipInfo.shipEmail = ShipDetails.shipEmail;
      prevState.shipInfo.phone1 = ShipDetails.phone1;
      prevState.shipInfo.phone2 = ShipDetails.phone2;
      prevState.shipInfo.invoiceForwardingEmail =
        ShipDetails.invoiceForwardingEmail;
      prevState.shipInfo.vesselGroupEmail = ShipDetails.vesselGroupEmail;
      prevState.shipInfo.companyName = ShipDetails.companyName;
      prevState.shipInfo.contractName = ShipDetails.contractName;
      prevState.shipInfo.contractStatus = ShipDetails.contractStatus;
      prevState.shipInfo.contractId = ShipDetails.contractId
        ? ShipDetails.contractId
        : 0;
      prevState.shipInfo.grantAdminId = ShipDetails.grantAdminId;
      prevState.shipInfo.approverId = ShipDetails.approverId;
      prevState.fleetmanager = ShipDetails.fleetManager;
      prevState.superintendent = ShipDetails.technicalSuperintendent;
      prevState.technicalexecutive = ShipDetails.technicalExecutive;
      if (ShipDetails.contractStatus === "active") {
        prevState.active = true;
      } else if (ShipDetails.contractStatus === "terminated") {
        prevState.terminated = true;
      } else if (ShipDetails.contractStatus === "pending") {
        prevState.pending = true;
      }
      prevState.shipInfo.shipUsers = [
        {
          userName: ShipDetails.fleetManager,
          role: "fleetmanager",
        },
        {
          userName: ShipDetails.technicalSuperintendent,
          role: "superintendent",
        },
        {
          userName: ShipDetails.technicalExecutive,
          role: "technicalexecutive",
        },
      ];
      dispatch({ type: "getShipManagementDetailSuccess", data: "" });
    }
    if (EquipmentArray) {
      prevState.Equipmentlist = EquipmentArray;
    }
  }
  AssignApprover() {
    const{t}=this.props;
    if (this.props.EquipmentArray && this.props.EquipmentArray.length !== 0) {
      confirmAlert({
        message: `${t("EditEquipmentScreenContent.ApproverWarningMsg")}`,
        buttons: [
          {
            label: `${t("confirmAlertMessage.Yes")}`,
            onClick: () => {
              const { dispatch, EquipmentArray } = this.props;
              this.state.shipInfo.status = "Approverapprovalpending";
              this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
              this.setState({});
              let url = `${API.getShipDetail}`;
              axios
                .put(url, this.state.shipInfo, {
                  headers: {
                    key: currentUser.accessToken,
                  },
                })
                .then((response) => {
                  if (response.status === 200) {
                    this.props.history.push(
                      `/Home/GrandAdmin/PendingShipDetails`
                    );
                    dispatch({
                      type: "PostShipDetailSuccess",
                      data: response.data,
                    });

                    toast.success(`${t("CommonText.AssignedSuccessfully")}`, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    dispatch(getShipSearchlist(searchData,this.state.inContract,this.state.isBoth));
                  }
                })
                .catch((error) => {
                  // swal(
                  //   "Error!",
                  //   "Something went wrong. Please try again.",
                  //   "warning"
                  // );
                  swal({
                    title: t('SwalError.ErrorTitle'), 
                    text: t('CommonText.500ErrorMessage'),  
                    icon: 'info',  
                    buttons: {
                      confirm: {
                        text: t('confirmAlertMessage.Ok')
                      }
                    }
                  });
                  dispatch({
                    type: "PostShipDetailFailure",
                    data: "error",
                  });
                });
            },
          },
          {
            label: `${t("confirmAlertMessage.No")}`,
            onClick: () => {},
          },
        ],
      });
    } else {
      swal("Error!", `${t("EditEquipmentScreenContent.AddEquipmentsMsg")}`, "warning");
    }
  }

  UpdateShip() {
    const { dispatch, EquipmentArray,t } = this.props;
    this.state.shipInfo.status = "pending";
    this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
    let url = `${API.getShipDetail}`;
    axios
      .put(url, this.state.shipInfo, {
        headers: {
          key: currentUser.accessToken,
        },
      })
      .then((response) => {
        // let equip = EquipmentArray.map(f => {
        //     let equipmentinfo = {
        //         shipId: f.shipId,
        //         equipmentId: f.equipmentId,
        //         shipEquipmentId: f.shipEquipmentId,
        //         equipment: f.equipment,
        //         manufracturingDate: f.manufracturingDate,
        //         make: f.make,
        //         model: f.model,
        //         quantity: f.quantity,
        //         serviceDetails: f.serviceDetails,
        //         modifiedBy: '',
        //         isDeleted: false
        //     }
        //     return equipmentinfo;
        // })
        // dispatch(UpdateEquipmentDetails(equip));
        if (response.status === 200) {
          this.props.history.push(`/Home/GrandAdmin/PendingShipDetails`);
          toast.success(`${t("CommonText.CommonUpdate")}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch({
            type: "PostShipDetailSuccess",
            data: response.data,
          });

          dispatch(getShipSearchlist(searchData,this.state.inContract,this.state.isBoth));
        }
      })
      .catch((error) => {
        // swal("Error!",   "Something went wrong. Please try again.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('CommonText.500ErrorMessage'),  
          icon: 'info',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
        dispatch({
          type: "PostShipDetailFailure",
          data: "error",
        });
      });
    //    dispatch(postEquipmentDetails());
  }

  CancelUpdateship() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/GrandAdmin/PendingShipDetails");
  }

  render() {
    const {
      showSidePane,
      flagList,
      ClientUsersList,
      ClientNameList,
      ClassList,
      TypeofShipList,
      t,
    } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="search-filter-box">
                    <div
                      className="card MM-card-header"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("ComplianceandBudgetScreen.Equipments")}
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showEquipmentSidePane()}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      {this.props.EquipmentArray &&
                      this.props.EquipmentArray.length ? (
                        this.renderEquipmentCard()
                      ) : (
                        <div
                          className="card"
                          style={{ overflow: "hidden", position: "relative" }}
                        >
                          <div class="container">
                            <h6 className="resource-list-title no-item-card">
                              {t("CommonText.NoEquipmentMsg")}
                            </h6>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="pb-4 pl-4 pr-4">
                    <div
                      className="search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.AssignApprover()}
                      >
                        {" "}
                        {t("EditEquipmentScreenContent.AssigntoApprover")}{" "}
                      </button>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                        type="submit"
                        onClick={() => this.UpdateShip()}
                      >
                        {" "}
                        {t("EditEquipmentScreenContent.Save")}{" "}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.CancelUpdateship()}
                      >
                        {" "}
                        {t("ComplianceandBudgetScreen.Cancel")}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderEquipmentCard = () => {
    const { showSidePane, EquipmentArray, t } = this.props;
    return (
      <>
        {EquipmentArray &&
          EquipmentArray.map((item) => (
            <div
              className="card MM-card-content mb-2 click"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className={"col-sm-9 col-md-10 col-9 m-auto"}>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 py-1">
                          <h6 className="resource-list-title m-0">
                            {item.equipment}
                          </h6>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? `col-md-6 col-sm-6 col-lg-6 py-1`
                              : `col-lg-4 py-1`
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.Category")}: </strong>
                            {item.category}{" "}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? `col-md-6 col-sm-6 col-lg-6 py-1`
                              : `col-lg-4 py-1`
                          }
                        >
                          <span>
                            <strong>
                              {t("ComplianceandBudgetScreen.Type")}:{" "}
                            </strong>
                            {item.equipmentType}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? `col-md-6 col-sm-6 col-lg-6 py-1`
                              : `col-lg-4 py-1`
                          }
                        >
                          <span>
                            <strong>
                              {t("ShipEquipmentStatusScreen.ManufacturingDate")}
                              :{" "}
                            </strong>
                            {item.manufracturingDate
                              ? Moment(
                                  new Date(Date.parse(item.manufracturingDate))
                                ).format("DD-MMM-YYYY")
                              : ""}
                          </span>
                        </div>
                        { item?.equipment.toLowerCase().includes("lifeboat")?
                                        <>
                                         <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </strong>
                                          {item.lifeboatMake}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </strong>
                                          {item.davitwinchMake}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </strong>
                                          {item.lifeboatModel}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.LifeboatRelease")} :{" "} </strong>
                                          {item.lifeboatRelease}{" "}
                                        </span>
                                      </div>
                                        </>
                                        :item?.equipment.toLowerCase().includes("rescue boat")?
                                        <>
                                           <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </strong>
                                          {item.rescueboatMake}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </strong>
                                          {item.rescueboatdavitwinchMake}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </strong>
                                          {item.rescueboatModel}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </strong>
                                          {item.rescueboatRelease}{" "}
                                        </span>
                                      </div>
                                        </>
                                        :
                                        <>
                                         <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Make")} : </strong>
                                          {item.make}{" "}
                                        </span>
                                      </div>
                                      <div className={showSidePane? `col-md-6 col-sm-6 col-lg-6 py-1`: `col-lg-4 py-1`}>
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Model")} : </strong>
                                          {item.model}{" "}
                                        </span>
                                      </div></>}
                                <div
                          className={
                            showSidePane
                              ? `col-md-6 col-sm-6 col-lg-6 py-1`
                              : `col-lg-4 py-1`
                          }
                        >
                          <span>
                            <strong>
                              {t("ShipEquipmentStatusScreen.Quantity")}:{" "}
                            </strong>
                            {item.quantity >0 ? item.quantity:""}
                          </span>
                        </div>
                        <div className={
                            showSidePane
                              ? `col-md-6 col-sm-6 col-lg-6 py-1`
                              : `col-lg-4 py-1`}>
                          <span>
                            <strong>{t("ShipEquipmentStatusScreen.Unit-Quantity")}:{" "} </strong>
                            {item.unit}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? `col-md-6 col-sm-6 col-lg-6 py-1`
                              : `col-lg-4 py-1`
                          }
                        >
                          <span>
                            <strong>
                              {t(
                                "EquipmentManagementScreenContent.Capacity/Size"
                              )}
                              :{" "}
                            </strong>
                            {item.capacity}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={"col-sm-3 col-md-2 col-3 m-auto"}>
                      <div
                        className="text-right"
                        style={{ marginLeft: "-5px" }}
                      >
                        <i
                          className="fa fa-edit fa-2x fa-lg px-1 m-1"
                          onClick={() => this.EditEquipment(item)}
                        ></i>
                        <i
                          className="fa fa-trash fa-2x px-2 m-1"
                          onClick={() => this.DeleteEquipment(item)}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  };

  DeleteEquipment(item) {
    const { match, dispatch, t } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            let EquipArray = [];
            let deleteEquip = {
              shipId: item.shipId,
              equipmentId: item.equipmentId,
              shipEquipmentId: item.shipEquipmentId,
              equipmentContractTypeId: item.equipmentContractTypeId ? item.equipmentContractTypeId : 0,
              equipment: item.equipment,
              recentlyUpdated : true,
              manufracturingDate: item.manufracturingDate,
              make: item.make,
              model: item.model,
              quantity: item.quantity,
              equipmentType: item.equipmentType,
              capacity: item.capacity,
              category: item.category,
              serviceDetails: item.serviceDetails,
              modifiedBy: currentUser.name,
              isDeleted: true,
            };
            EquipArray.push(deleteEquip);
            let url = `${API.postShipEquipment}`;
            axios
              .put(url, EquipArray)
              .then((response) => {
                dispatch(getShipEquipmentDetails(id));
                dispatch({
                  type: "UpdateEquipmentDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "UpdateEquipmentDetailFailure",
                  data: "error",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {},
        },
      ],
    });
  }

  EditEquipment(item) {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "editEquipment", data: true });
    this.props.dispatch({ type: "getEquipmentDetails", data: item });
    this.props.history.push(
      `/Home/GrandAdmin/ShipEditItem/${this.props.match.params.id}/Equipment`
    );
    window.scrollTo(0, 0);
  }

  showEquipmentSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "editEquipment", data: false });
    this.props.dispatch({ type: "getEquipmentDetails", data: "" });
    this.props.dispatch({
      type: "getEquipmentDropDownListSuccess",
      data: null,
    });
    this.props.dispatch({ type: "getMakesListEquipmentSuccess", data: [] });
    this.props.dispatch({ type: "getModelsListEquipmentSuccess", data: [] });
    this.props.dispatch({ type: "getServiceTypeListSuccess", data: null });
    this.props.dispatch({
      type: "getServiceTypeIntervalListSuccess",
      data: null,
    });
    this.props.dispatch({
      type: "getServiceTypeIntervalListFlagSuccess",
      data: null,
    });
    this.props.history.push(
      `/Home/GrandAdmin/ShipEditItem/${this.props.match.params.id}/NewEquipment`
    );
    this.props.dispatch({ type: "annualAttachmentUploadSuccess", data: "" });
    this.props.dispatch({ type: "getShipServiceProviderIDSuccess", data: [] });
    window.scrollTo(0, 0);
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    FirePlanAttachment: state.lookupReducer.FirePlanAttachment || null,
    flagList: state.MasterScreenReducer.flagList,
    ClientUsersList: state.MasterScreenReducer.ClientUsersList,
    ClientNameList: state.MasterScreenReducer.ClientNameList,
    showSidePane: state.SidePanReducer.sidePan,
    EquipmentArray: state.MasterScreenReducer.ShipEquipmentDetails,
    ClassList: state.MasterScreenReducer.ClassList,
    companyName: state.MasterScreenReducer.companyName,
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
    TypeofShipList: state.MasterScreenReducer.TypeofShipList,
  };
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ShipEquipmentEdit))
);
